import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel";
import { useEffect } from "react";

function ZoomToolbar({ zoom, setZoom, onZoomIn, onZoomOut, onReset }) {
    // keyboard: + / - / 0
    useEffect(() => {
        const onKey = (e) => {
        if (['INPUT','TEXTAREA'].includes(e.target.tagName)) return;
        if (e.key === '+' || e.key === '=') onZoomIn();
        if (e.key === '-') onZoomOut();
        if (e.key === '0') onReset();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onZoomIn, onZoomOut, onReset]);

    const clamp = (z) => Math.max(0.4, Math.min(2, z));

    return (
        <div className="ztb">
            <div className="ztb-glass" role="toolbar" aria-label="Zoom controls">
                <button className="ztb-btn" title="Zoom out (–)" onClick={onZoomOut} aria-label="Zoom out">
                <svg viewBox="0 0 24 24" fill="none"><path d="M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                </button>

                <TCLabel style={{
                    minWidth: 30
                }}>{Math.round(zoom * 100)}%</TCLabel>

                <button className="ztb-btn" title="Zoom in (+)" onClick={onZoomIn} aria-label="Zoom in">
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                </button>

                <div className="ztb-divider" />

                <div className="ztb-slider-wrap" title="Drag to set zoom">
                <input
                    className="ztb-slider"
                    type="range"
                    min="0.4"
                    max="2"
                    step="0.01"
                    value={zoom}
                    onChange={(e) => setZoom(clamp(parseFloat(e.target.value)))}
                    aria-label="Zoom slider"
                />
                </div>

                <div className="ztb-divider" />

                <button className="ztb-btn" title="Reset (0)" onClick={onReset} aria-label="Reset zoom">
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 5a7 7 0 1 1-4.95 2.05" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M7 5H3v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                </button>
            </div>
        </div>
    );
}

export default ZoomToolbar;